import * as fromActions from '../actions';
import { LugaresAtencionState } from '../models/store.models';

const initialState: LugaresAtencionState = {
    lugarAtencionList: {
        contenido: [],
        paginado: {
            elementosTotales: 0,
            paginaActual: 0,
            paginasTotales: 0,
        },
    },
    search: {
        searchTerm: [''],
        searchCriteria: ['cuit'],
    },
};

export function lugaresAtencionReducer(
    state: LugaresAtencionState = initialState,
    action: fromActions.LugaresAtencionActions
): LugaresAtencionState {
    switch (action.type) {
        case fromActions.SET_LUGARES_ATENCION:
            return {
                lugarAtencionList: {
                    contenido: action.lugarAtencionSeteado.contenido,
                    paginado: {
                        elementosTotales:
                            action.lugarAtencionSeteado.paginado
                                .elementosTotales,
                        paginaActual:
                            action.lugarAtencionSeteado.paginado.paginaActual,
                        paginasTotales:
                            action.lugarAtencionSeteado.paginado.paginasTotales,
                    },
                },
                search: state.search,
            };
        case fromActions.SET_LUGAR_ATENCION_SEARCH_TERM:
            return {
                lugarAtencionList: state.lugarAtencionList,
                search: {
                    searchTerm: [...action.search.searchTerm],
                    searchCriteria: [...action.search.searchCriteria],
                },
            };
        // case fromActions.SET_SINGLE_LUGAR_ATENCION:
        //     const updatedLugaresAtencion = state.lugaresAtencion.map(
        //         (lugarAtencion) =>
        //             lugarAtencion.id === action.lugarAtencionSeteado.id
        //                 ? { ...lugarAtencion, ...action.lugarAtencionSeteado }
        //                 : lugarAtencion
        //     );
        //     return {
        //         ...state,
        //         lugaresAtencion: updatedLugaresAtencion,
        //     };
        default:
            return state;
    }
}
